export function doSomeMagicWithKey(key: string): string {
  // Capitalize single letter keys
  if (key.length === 1) return key.toUpperCase();

  return key
    .replace('meta', '⌘')
    .replace('ctrl', '⌃')
    .replace('shift', '⇧')
    .replace('alt', '⌥')
    .replace('option', '⌥')
    .replace('enter', '↩')
    .replace('return', '↩');
}

export function doSomeMagicWithKeys(keys: string[]): string[] {
  return keys.map((k) => doSomeMagicWithKey(k));
}
